import { render, staticRenderFns } from "./atDialog.vue?vue&type=template&id=0b2924aa&scoped=true"
import script from "./atDialog.vue?vue&type=script&lang=js"
export * from "./atDialog.vue?vue&type=script&lang=js"
import style0 from "./atDialog.vue?vue&type=style&index=0&id=0b2924aa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2924aa",
  null
  
)

export default component.exports